<template>

  <v-container fluid>
    <p class="font-weight-bold title text-center">Оператор: {{user.last_name}} {{user.first_name}}</p>
    <p class="font-weight-bold title">Ваш список заявлений</p>
    <v-sheet>
      <v-simple-table
      :fixed-header="fixedHeader"
      :height="height"
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center">№ заявления</th>
            <th class="text-center">ФИО</th>
            <th class="text-center">Этап выполнения</th>
            <th class="text-center">Действия</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in application_operator" :key="item.id">
            <td class="text-center">{{ item.application.id }}</td>
            <td class="text-center">{{ item.application.abiturient.last_name +' '+ item.application.abiturient.first_name }}</td>
            <td class="text-center">
              <p v-if="item.application.is_done === true">
                <v-icon  large color="green darken-2">{{mdiCheck}}</v-icon> Выполнено
              </p>
              <p v-else-if="item.application.is_reject === true && item.application.is_work === false && item.application.is_close === false">
                <v-icon large color="red darken-2">{{mdiAlertCircleOutline}}</v-icon> На доработке: {{item.application.messege_reject}}
              </p>
              <p v-else-if="item.application.is_reject === true && item.application.is_work === true">
                <v-icon large color="yellow darken-2">{{mdiAlertCircleOutline}}</v-icon> Изменено абитуриентом
              </p>
              <p v-else-if="item.application.is_reject === true && item.application.is_close === true">
                <v-icon large color="yellow darken-2">{{mdiClose}}</v-icon> Предварительно отклонено
              </p>
              <p v-else-if="item.application.is_close === true && item.application.is_reject === false">
                <v-icon large color="red darken-2">{{mdiClose}}</v-icon> Отклонено администратором
              </p>
              <p v-else>Новое заявление</p>
            </td>
            <td class="text-center"><v-btn class="mx-2" color="primary" link :to="{
            name: 'operator_check_application',
            params:{
              id:item.application.id
            }
            }">Просмотр</v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="warning"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Прикрепить
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <send_contract v-bind:application=item.application></send_contract>
                  </v-list-item>
                  <v-list-item>
                    <send_blank_exam v-bind:application=item.application></send_blank_exam>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
    <v-row class="px-2 mb-3 mt-5" v-if="user.is_superuser ===true">
      <v-btn color="success" v-on:click="saveFiles()">Выгрузить заявления на доработке csv</v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import { mdiCheck,mdiClose,mdiAlertCircleOutline} from '@mdi/js'
  import send_contract from "@/components/operator/send_contract.vue";
  import send_blank_exam from "@/components/operator/send_blank_exam.vue";

  export default {
    name: "profile",
    data: () => ({
      mdiCheck,
      mdiClose,
      mdiAlertCircleOutline,
      fixedHeader: true,
      height: 600,

    }),
    methods: {
      saveFiles: function () {
        this.overlay = true;
        Vue.axios.get('operator/excel/', {
          responseType: 'blob'
          },
        ).then(response => {
          this.overlay = false;
          let blob = new Blob([response.data], {type: 'text/csv'}),
            url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = 'Заявления на доработке.csv';
          a.click();
        });
      },
    },
    computed: {
          ...mapGetters("auth", ["user"]),
          ...mapGetters("operator", ["application_operator"]),
        },
    created() {
      this.$store.dispatch('operator/loadApplicationsOperator')
    },
    components: {
      send_contract,
      send_blank_exam,
    },
  };
</script>

<style scoped>

</style>
